import { ExpedientesService } from './../../services/expedientes.service';
import { Component, OnInit } from '@angular/core';
import { ClientesService } from "./../../services/clientes.service";
import { Router } from '@angular/router';
@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.css']
})
export class ClientesComponent implements OnInit {
  
  
  clientes:any[] = [];
  activo:boolean=true;
  filtro={
    nombre :"",
    email: "",
    telefono:"",
    cif:"",
    activo:true,
    ultimoacceso:""
  }
  
  paginaActual:number=1;
  paginaSiguiente:number;
  paginaAnterior:number;
  totalPaginas:number;

  ordenacion={};

  constructor(private _clientesService:ClientesService, private router:Router, 
              private expedientesService:ExpedientesService) {
    
  }

  ngOnInit() {

    this.ordenacion['campo']="CLfechaultimoacceso";
    this.ordenacion['orden']="DESC";
    
    this.getClientesPorFiltro();
  }

  getClientesPorFiltro(){
    this._clientesService.getClientes(this.filtro, this.paginaActual, this.ordenacion)
        .subscribe(resp =>{
          this.clientes=resp["clientes"];
          this.paginaActual=parseInt(resp["pagina"]);
          this.paginaAnterior=parseInt(resp["pag_anterior"]);
          this.paginaSiguiente=parseInt(resp["pag_siguiente"]);
          this.totalPaginas=parseInt(resp["total_paginas"]);
        })
  }

  checkActivo(i:number){
    let returnValue=false;
    if(this.clientes[i].CLactivo=="1"){
      returnValue=true;
    }
    return returnValue;
  }
  checkGestoria(i:number){
    let returnValue=false;
    if(this.clientes[i].CLgestoria=="1"){
      returnValue=true;
    }
    return returnValue;
  }

  limpiarCampos(){
    this.filtro.nombre="";
    this.filtro.cif="";
    this.filtro.email="";
    this.filtro.activo=true;
    this.filtro.telefono="";
    this.filtro.ultimoacceso="";
  }

  getTodos(){
    this.limpiarCampos();
    this.getClientesPorFiltro();
  }

  actualizarEstado(codigo){
    if(confirm("¿Desea cambiar el estado del cliente seleccionado?")){
        this._clientesService.actualizarEstado(codigo)
      .subscribe(resp=>{
        alert(resp["mensaje"]);
        this.getClientesPorFiltro();
      })
    }
    
  }

  nextPage(){
    this._clientesService.getClientes(this.filtro, this.paginaSiguiente, this.ordenacion)
    .subscribe(resp=>{
      this.clientes = resp["clientes"];
          this.paginaActual=parseInt(resp["pagina"]);
          this.paginaAnterior=parseInt(resp["pag_anterior"]);
          this.paginaSiguiente=parseInt(resp["pag_siguiente"]);
          this.totalPaginas=parseInt(resp["total_paginas"]);
    })
  }

  previousPage(){
    this._clientesService.getClientes(this.filtro, this.paginaAnterior, this.ordenacion)
    .subscribe(resp=>{
      this.clientes=resp["clientes"];
          this.paginaActual=parseInt(resp["pagina"]);
          this.paginaAnterior=parseInt(resp["pag_anterior"]);
          this.paginaSiguiente=parseInt(resp["pag_siguiente"]);
          this.totalPaginas=parseInt(resp["total_paginas"]);
    })
  }

  borrarCliente(cliente){
    let respuesta= prompt('Si desea borrar este cliente, escriba "borrar" en el campo de texto.');
    if(respuesta==="borrar"){
      this._clientesService.borrarCliente(cliente.CLcodigo)
      .subscribe(resp=>{
        alert(resp["msg"]);
        this.getClientesPorFiltro();
      });
    }else{
      alert("Cliente no borrado.");
    }
  }

  ordenarTabla(campo){
    
    if(this.ordenacion['campo']==campo && this.ordenacion['orden']=='DESC'){
      this.ordenacion['orden']='ASC';
    }else{
      this.ordenacion['campo']=campo;
      this.ordenacion['orden']='DESC';
    }

    

    this.getClientesPorFiltro();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/clientes/clientes.component.ts